export default {"src":"/_next/static/media/residential3.7418beb5.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};